export default "__VITE_ASSET__39bfb564__"